import React from 'react';
import styles from './Contact.module.css';

function Contact() {
  return (
    <section id="contact" className={styles.contactSection}>
      <h2 className={styles.sectionTitle}>Get in Touch</h2>
      <p className={styles.description}>
        Have questions or want to learn more about our apps?
      </p>
      <a href="mailto:admin@raggedspade.com" className={styles.email}>
        admin@raggedspade.com
      </a>
    </section>
  );
}

export default Contact;
